function e(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
export {
  e as isObject
};
